// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2A8WS","legacyBtn":"MutateMid_legacyBtn__2Qj80"};